<template>
  <!-- 投诉管理 -->
  <div class="firm-body">
    <!-- 标题 投诉管理 -->
    <div class="title-Individual-center">
      企业中心 <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">投诉管理</span>
    </div>
    <!-- 主体部分 -->
    <div class="firm-Content-subject">
      <!-- 切换 -->
      <div class="Toggle">
        <div
          v-for="(item, index) in selectArr"
          :key="index"
          class="toggle-item"
          :class="select == item.id ? 'select-p' : ''"
          @click="handelSelect(item.id)"
        >
          {{ item.name }} ({{ item.frequency }})
        </div>
      </div>
      <!-- 搜索 -->
      <el-form class="screen" :inline="true" @submit.native.prevent>
      <el-form-item v-if="select == '0'" label="投诉类型：">
      <div class="size-search">
      <el-select v-model="value" placeholder="请选择">
      <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      >
      </el-option>
      </el-select>
      </div>
      </el-form-item>
      <el-form-item label="投诉状态：" :class="select == '0' ? 'user-Id' : ''">
      <div class="size-search">
      <el-select v-model="valStatus" placeholder="请选择">
      <el-option
      v-for="item in options1"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      >
      </el-option>
      </el-select>
      </div>
      </el-form-item>
      
      <div class="screen-end">
      <el-form-item label="时间：" class="user-Id">
      <el-date-picker
      v-model="value1"
      type="daterange"
      range-separator="-"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyy-MM-dd"
      unlink-panels
      clearable
      @clear="value1 = null"
      >
      </el-date-picker>
      </el-form-item>
      <el-form-item>
      <el-button type="primary" class="ser-btn public-style" @click="handelSearch">搜 索</el-button>
      <el-button class="heavy-btn public-style" @click="handelReset">重 置</el-button>
      </el-form-item>
      </div>
    
    </el-form>
      <!-- 表格 -->
      <div class="tabulation">
        <PlainTable
          v-if="select == '0'"
          :tableData="tableData"
          @RefreshList="RefreshList"
        ></PlainTable>
        <BePlainTable
          v-if="select == '1'"
          :tableData="tableData"
          @RefreshList="RefreshList"
        ></BePlainTable>
      </div>
      <!-- 底部分页 -->
      <div class="paging-box">
        <div class="paging">
          <paging
            :pagingObj="pagingObj"
            @handleCurrentChange="handleCurrentChange"
          ></paging>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入接口
import {
  getComplaintCount, //获取投诉界面统计数量
  listComplaint, //分页查询投诉列表
} from "../../../../assets/api/firm/firmCenter";
// 引入投诉表格 组件
import PlainTable from "./components/PlainTable.vue";
// 引入被投诉 表格组件
import BePlainTable from "./components/BePlainTable.vue";
// 引入分页组件
import paging from "../../../../components/paging.vue";
export default {
  data() {
    return {
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 分页数据
      selectArr: [
        { name: "投诉", id: "0", frequency: "" },
        { name: "被投诉", id: "1", frequency: "" },
      ], // 上方切换 投诉被投诉
      options: [
        {
          value: "1",
          label: "全部",
        },
        {
          value: "2",
          label: "个人",
        },
        {
          value: "3",
          label: "企业",
        },
      ], // 搜索下拉框数据
      options1: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "完成",
        },
        {
          value: "1",
          label: "处理中",
        },
        {
          value: "2",
          label: "撤销",
        },
        {
          value: "3",
          label: "投诉人待确认",
        },
        {
          value: "4",
          label: "被投诉人待确认",
        },
      ], // 搜索下拉框数据
      select: "0", // 筛选
      value: "1", // 投诉类型
      valStatus: "", // 投诉状态
      value1: null,
      tableData: [], // 表格数据
    };
  },
  watch: {

  },
  components: { paging, PlainTable, BePlainTable },
  created() {
    this.getComplaintCount(); //获取投诉界面统计数量
    this.listComplaint();
  },
  methods: {
    // 获取投诉界面统计数量
    getComplaintCount() {
      getComplaintCount().then((res) => {
        if (res.code == 0) {
          for (var i in this.selectArr) {
            if (this.selectArr[i].name == "投诉") {
              this.selectArr[i].frequency = res.data.complaintCount;
            } else {
              this.selectArr[i].frequency = res.data.accusedCount;
            }
          }
        }
      });
    },
    // 分页查询投诉列表
    async listComplaint() {
      // this.tableData = [];
      // 处理时间筛选
      var time;
      var timeEnd;
      var range = this.value1;
      if (Array.isArray(range) && range.length === 2 && range[0] && range[1]) {
        time = range[0] + " " + "00:00:00";
        timeEnd = range[1] + " " + "23:59:59";
      }
      // 接口所需参数
      var data = {
        data: {
          userId: this.$store.getters.getUser.id,
          // 那个页面 投诉0 被投诉1
          compPage: this.select,
          // 投诉类型集合 [0]对个人 [1]对企业 [0,1]全部
          complaintTypeList:
            this.select == "1"
              ? [1, 2, 3, 5]
              : this.select == "0" && this.value == "1"
              ? [3, 4, 5]
              : this.select == "0" && this.value == "2"
              ? [4]
              : this.select == "0" && this.value == "3"
              ? [3, 5]
              : "",
          // 投诉状态 完成0 处理中1 撤销2 投诉人待确认3 被投诉人待确认4
          compStatus: this.valStatus,
          // 开始时间
          startTime: time,
          // 结束时间
          endTime: timeEnd,
        },
      };
      // 调用接口
      const res = await listComplaint(
        data,
        this.pagingObj.currentPage, // 当前页
        this.pagingObj.pageSize // 一页几条
      );
      // 调用成功
      if (res.code == 0) {
        this.tableData = res.data.list;
        this.pagingObj.totalDevice = res.data.total;
      } else {
        // 调用失败
        // this.$tool.PromptBox("error", res.msg);
      }
    },
    // ------------------- 刷新列表数据 (在操作表格后有些需要刷新数据列表)-------------------
    RefreshList() {
      this.listComplaint();
    },
    // -------------------- 搜索 ------------------------
    handelSearch() {
      this.pagingObj = {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      };
      this.listComplaint();
    },
    // -------------------- 重置 -----------------------
    handelReset() {
      this.pagingObj = {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      };
      this.value = "1"; // 投诉类型
      this.valStatus = ""; // 投诉状态
      this.value1 = null;
      this.listComplaint();
    },
    // 筛选
    handelSelect(num) {
      this.tableData = []
      this.pagingObj = {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      };
      this.select = num;
      this.value = "1"; // 投诉类型
      this.valStatus = ""; // 投诉状态
      this.value1 = null;
      // this.$emit("handelSelect", num);
      this.listComplaint();
    },
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      this.listComplaint();
    },
  },
};
</script>

<style scoped lang="less">
.firm-body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .firm-Content-subject {
    width: 100%;
    min-height: 540px;
    box-sizing: border-box;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
  }
}
// 切换
.Toggle {
  width: 100%;
  height: 30px;
  display: flex;
  color: #333333;
  text-align: center;
  font-weight: 400;
  .toggle-item:nth-child(1) {
    margin-left: 20px;
  }
  .toggle-item {
    margin-right: 40px;
    font-size: 16px;
    cursor: pointer;
  }
  .select-p {
    color: #409eff ;
    box-sizing: border-box;
    border-bottom: 2px solid #409eff ;
  }
}
// 搜索
.screen {
  margin-top: 30px;
  margin-bottom: 0;
  position: relative;
  .Back {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 0px;
    top: 10px;
  }
}
// 表格
.tabulation {
  width: 100%;
  min-height: 450px;
  margin-top: 30px;
}
// 分页
.paging-box {
  width: 100%;
  height: 22px;
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
  .paging {
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
